import { storage } from "@/CommonDP/utils";
const commonH5 = {
  state: {
    hasBottomNavBar: storage.get("navBottomBar") || true
  },
  actions: {
    setNavBottomBar({ commit }, boolean) {
      commit('SET_NAVBAR', boolean);
    }
  },
  mutations: {
    SET_NAVBAR(state, boolean) {
      storage.set("navBottomBar", boolean);
      state.hasBottomNavBar = boolean;
    }
  }
};
export default commonH5;
